// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-a55ppw{width:100%}.select-a55ppw .select-name-ZZOaPQ{margin-left:6px;font-weight:600}.select-item-icon-oEanPQ svg{width:24px;height:24px}.select-item-name-TvYl12{margin-left:12px;margin-right:16px;font-weight:600}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `select-a55ppw`,
	"select-name": `select-name-ZZOaPQ`,
	"selectName": `select-name-ZZOaPQ`,
	"select-item-icon": `select-item-icon-oEanPQ`,
	"selectItemIcon": `select-item-icon-oEanPQ`,
	"select-item-name": `select-item-name-TvYl12`,
	"selectItemName": `select-item-name-TvYl12`
};
export default ___CSS_LOADER_EXPORT___;
